import { useSelector } from "react-redux";

import Link from "@mui/material/Link";
import { HashLink } from 'react-router-hash-link';
import ScrollWithOffset from "../scroll/ScrollWithOffSet";


const NavLink = ({page, color}) =>{
    const currentSection = useSelector((state) => state.sections.currentSection);
    return(
        <Link 
            component={HashLink}
            key={page.key}
            smooth
            to={page.url}
            scroll={el => ScrollWithOffset(el)}

            sx={{
                display: "block",
                position: "relative",
                py: "0.2em",
                px:2,
                
                textDecoration:"none",
                color:color,
                "overflow": "hidden",
                "&:hover::after, &:focus::after":{
                    opacity: 1,
                    transform: "translate3d(0, 0, 0)"
                },
                ...(page.section === currentSection ? {
                    fontSize:"0.93em",
                    fontWeight:800,
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "0.2em",
                        bgcolor: color,
                    },
                }
                :
                {
                    fontSize:"0.90em",
                    fontWeight:400,
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: "100%",
                        height: "0.2em",
                        bgcolor: color,
                        opacity: 0,
                        transition: "opacity 300ms, transform 300ms",
                        transform: "translate3d(-100%, 0, 0)",
                    },
                }),
            }}
        >
            {page.title}
        </Link>
    );
}

export default NavLink;